import Vue from 'vue';
import { Decimal } from 'decimal.js';
import BigNumber from 'bignumber.js';

import Config from './Config';

BigNumber.config({
    ROUNDING_MODE: BigNumber.ROUND_FLOOR,
});

Vue.filter('formatPrice', (value, prec) => {
    if (value === '-' || isNaN(value)) {
        return value;
    }
    if (value) {
        return Number((new Decimal(value)).toFixed(prec || 6, Decimal.ROUND_DOWN));
    }
    return '';
});

Vue.filter('toNumber', (value) => {
    if (value === '-') {
        return value;
    }
    if (value && !isNaN(value)) {
        return Number(value);
    }
    return '';
});

// 主链地址
Vue.filter('blockTxUrl', value => `//${Config.BlockURL}/transaction-info.html?id=${value}&blockType=1`);

// 以太坊地址
Vue.filter('toEthTxUrl', (value, assetId) => {
    let Url = Config.EthURL;
    let assets = localStorage.getItem('assets');
    if (assets) {
        assets = JSON.parse(assets).filter(asset => asset.id == assetId);
    } else {
        assets = [];
    }
    if (assets.length > 0) {
        if (assets[0].chain_type === 3) {
            Url = Config.CMTURL;
        }
    }
    return `https://${Url}/tx/${value}`;
});


Vue.filter('formatPrice1', (value) => {
    if (value) {
        let len = 6;
        if (localStorage.getItem('depth') === '0.000001') {
            len = 6;
        } else if (localStorage.getItem('depth') === '0.00001') {
            len = 5;
        } else if (localStorage.getItem('depth') === '0.0001') {
            len = 4;
        } else if (localStorage.getItem('depth') === '0.001') {
            len = 3;
        }
        return Number((new Decimal(value)).toFixed(len, Decimal.ROUND_DOWN));
    }
    return '';
});
Vue.filter('getAssetType', (id) => {
    const assets = localStorage.getItem('assets');
    if (assets) {
        const assetsArr = JSON.parse(assets);
        const asset = assetsArr.filter(item => item.id === parseInt(id))[0];
        return asset.asset;
    }
    return '';
});
Vue.filter('toFixed', (val, prec, returnNotValid, replenishZero) => {
    if (isNaN(val)) {
        if (returnNotValid) {
            return val;
        }
        return BigNumber(0).toFixed(prec);
    }
    if ((val == 0 || val == '0.0') && !replenishZero) {
        return val;
    }
    return BigNumber(val).toFixed(prec);
});
Vue.filter('toChange', (val) => {
    let change = val;
    if (val != '-1') {
        change = parseFloat((change - 1) * 100);
    } else {
        change = 0;
    }
    return change;
});
Vue.filter('toShowChange', val => (val > 0 ? (`+${val}`) : val));
Vue.filter('showStatus', (val) => {
    const statusMap = {
        0: 'Waiting for payment, ',
        1: 'Success',
        2: 'Pay success',
        3: 'Verifing',
        4: 'Sent',
        11: 'Refund',
        12: 'Rejected',
        13: 'Fail',
    };
    if(val == -1) {
        return 'Canceled';
    }
    if (statusMap[val]) {
        return statusMap[val];
    }
    return val;
});




// WEBPACK FOOTER //
// ./src/utils/filters.js